export default {
	props: {
		formCreateInject: {
			type: Object,
			default: () => {
				return null
			}
		},
		el: {
			type: Boolean,
			default: () => {
				return false
			}
		},
		name: {
			type: String,
			default: () => {
				return ''
			}
		},
		size: {
			type: String,
			default: () => {
				return 'small'
			}
		},
		disabled: {
			type: Boolean,
			default: () => {
				return false
			}
		},
		placeholder: {
			type: String,
			default: () => {
				return ''
			}
		},
		value: {
			default: () => {
				return ''
			}
		},
		readonly: {
			default: () => {
				return false
			}
		},
		renderCell: {
			type: Boolean,
			default: () => {
				return false
			}
		}
	},
	data() {
		return {
			ready: false,
		}
	},
	created() {

		
	},
	watch: {

	},
	computed: {

	},

	methods: {
		change(val) {
			
			//console.log(Object.hasOwn(val,'value') ? val.value : val)
			this.$emit('change', Object.hasOwn(val, 'value') ? val.value : val)
			this.$emit('input', Object.hasOwn(val, 'value') ? val.value : val)
			if (this.el) {
				this.formCreateInject.api.validateField(this.formCreateInject.field)
			}
		},
		finish() {
			this.ready = true
			this.$emit('ready')
		}
	}
}
